import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-progress-percent',
  templateUrl: './progress-percent.component.html',
})
export class ProgressPercentComponent {
  @Input() percent: number;
}
